import { useState, useEffect } from "react";
import { UserQuery } from "designSystem/user";
import { MentionUser } from "./tributeService";

export type UserSearchCallback = (users: MentionUser[]) => void
export type SetUserSearchCallback = (func: UserSearchCallback) => void

export type SetUserSearchQuery = (query: UserQuery) => void
export type UserSearchQuery = (query: UserQuery) => Promise<MentionUser[]>

const useMentionUser = (initUsers: MentionUser[], getUserList: UserSearchQuery): [SetUserSearchQuery, SetUserSearchCallback] => {
	const [userSearchQuery, setUserSearchQuery] = useState<UserQuery>(null);
	const [users, setUsers] = useState<MentionUser[]>(initUsers);
	const [userCallback, setUserCallback] = useState<UserSearchCallback>((userList: MentionUser[]) => { });

	useEffect(() => {
		if (userSearchQuery == null) {
			return;
		}
		getUserList?.(userSearchQuery)
			.then((newUserList) => {
				setUsers(newUserList);

				// only callback when the data is ready to avoid the exception from tribute library
				if (newUserList) {
					userCallback(newUserList);
				}
			});
	}, [userSearchQuery, getUserList]);

	return [setUserSearchQuery, setUserCallback];
};
export default useMentionUser;